<template>
  <section class="p-2">
    <v-card class="">
      <v-card-title class="d-flex justify-space-between p-0 m-0">
        <div class="ps-2 headingFontsize">Deals</div>
        <div>
          <bread-crumb :bread-crumbs="['Deals']" />
        </div>
      </v-card-title>
      <v-divider class="p-0 m-0 primary--text"></v-divider>

      <v-card-text>
        <v-row justify="space-between">
          <v-col cols="6" lg="4" xs="12">
            <v-btn
              depressed
              small
              color="primary text-capitalize"
              class="mr-2 action-btn"
              title="New Deal"
              @click="newDealClick()"
            >
              New Contract
            </v-btn>
            <v-btn depressed @click="downloadExcelsheet" color="primary" small
              ><v-icon small>mdi-file-excel-outline</v-icon>Export
            </v-btn>
          </v-col>
          <v-col cols="6" lg="4" xs="12">
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Type here to filter the table data."
              hide-details
              dense
              single-line
              clearable
              class="mt-3"
            ></v-text-field>
          </v-col>
        </v-row>
      </v-card-text>
      <v-data-table fixed-header  height="55vh"
        :headers="headers"
        :items="userList"
        :single-expand="true"
        :expanded.sync="expanded"
        item-key="deal_id"
        show-expand
        :search="search"
        class="py-4"
        dense
      >
        <template v-slot:item.status="{ item }">
          <v-chip
            :color="getStatusColor(item.status)"
            class="text-capitalize text-white"
            small
          >
            {{ item.status }}
          </v-chip>
          <v-btn
            v-if="item.status === 'open'"
            depressed
            icon
            color="primary"
            @click="updateStatus(item)"
            title="Update Status"
            class="text-capitalize text-white"
            small
          >
            <v-icon>mdi-content-save-edit-outline</v-icon>
          </v-btn>
        </template>

        <template v-slot:item.action="{ item }">
          <div class="d-flex">
            <v-icon
              small
              title="Edit"
              color="primary"
              class="mr-2"
              @click="updateDeal(item)"
            >
              mdi-content-save-edit-outline
            </v-icon>
            <v-icon
              small
              title="Delete"
              color="primary"
              class="mr-2"
              @click="deleteItem(item)"
            >
              mdi-trash-can-outline
            </v-icon>
            <v-icon
              small
              title="Settlement"
              color="primary"
              class="mr-2"
              @click="
                $router.push({
                  name: 'Settlements',
                  query: { id: item.deal_id },
                })
              "
            >
              mdi-chevron-right-circle-outline
            </v-icon>
          </div>
          <!-- <v-badge color="grey" content="1" small shape="circle"> -->
        </template>
        <template v-slot:expanded-item="{ headers, item }">
          <td :colspan="headers.length">
            <v-row justify="space-between" class="ma-5">
              <v-col cols="12" lg="12" xs="12">
                <v-row justify="space-between">
                  <span class="text-h6 font-weight-light title-lbl"
                    >Additional Info</span
                  >
                  <v-col cols="12" lg="6" xs="12">
                    <div class="menu-sec">
                      <v-list-item class="v-flex">
                        <label>Contract Number</label>
                        <b>{{ item.deal_no }}</b>
                      </v-list-item>
                      <v-list-item class="v-flex">
                        <label>Confirmation Date</label>
                        <b>{{ format(item.purchase_date) }}</b>
                      </v-list-item>

                      <v-list-item class="v-flex">
                        <label>Settlements</label>
                        <b>{{ item.no_of_settlements }}</b>
                      </v-list-item>

                      <v-list-item class="v-flex">
                        <label>Contract Person</label>
                        <b>{{ item.bank_poc }}</b>
                      </v-list-item>
                    </div>
                  </v-col>
                  <v-col cols="12" lg="6" xs="12">
                    <div class="menu-sec">
                      <v-list-item
                        class="d-flex justify-content-between align-items-center"
                      >
                        <label>Edited by</label>
                        <b>{{ item.updated_by }}</b>
                      </v-list-item>
                      <v-list-item
                        class="v-flex justify-content-between align-items-center"
                      >
                        <label>Created by</label>
                        <b>{{ item.created_by }}</b>
                      </v-list-item>
                    </div>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="12" lg="3" xs="12">
                <div class="menu-sec pt-10">
                  <!-- <v-btn depressed 
                    small
                    color="primary"
                    size="sm"
                    class="wd-100p mb-2"
                    @click="updateDeal(item)"
                  >
                    <b-icon
                          icon="pencil-square"
                          aria-hidden="true"
                        ></b-icon>
                    <v-icon small class="me-2"
                      >mdi-content-save-edit-outline</v-icon
                    >
                    Update
                  </v-btn> -->
                  <!-- <v-btn depressed 
                    color="primary"
                    size="sm"
                    small
                    class="wd-100p mb-2"
                    @click="newSettlementClicked(item)"
                  >
                    <v-icon small>mdi-plus</v-icon> Settlement
                  </v-btn> -->
                  <!-- <v-btn depressed 
                    color="primary"
                    outlined
                    size="sm"
                    small
                    class="wd-100p mb-2"
                    @click="deleteDeal(item)"
                  >
                    <b-icon icon="trash-fill" aria-hidden="true"></b-icon>
                    Delete
                  </v-btn> -->
                </div>
              </v-col>
            </v-row>
          </td>
        </template>
      </v-data-table>
      <v-dialog persistent v-model="dialogstatus" width="500">
        <v-card>
          <v-card-title class="border border-bottom"
            >Update Status</v-card-title
          >
          <v-card-text class="h5 py-3"
            >Are you sure you want to update deal status from <b>open</b> to
            <b>Settled</b></v-card-text
          >
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
            <v-btn
              depressed
              small
              color="primary"
              outlined
              @click="isactiveupdate()"
            >
              <v-icon>mdi-check</v-icon>
            </v-btn>
            <v-btn
              depressed
              small
              color="primary"
              outlined
              @click="(dialogstatus = false), (statusdeal_id = null)"
              ><v-icon>mdi-close</v-icon></v-btn
            >
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- delete dialog -->
      <v-dialog persistent v-model="dialogDelete" width="500">
        <v-card>
          <v-card-title class="border border-bottom">Delete</v-card-title>
          <v-card-text class="h5 py-3"
            >Are you sure you want to delete?</v-card-text
          >
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              depressed
              small
              color="primary"
              outlined
              @click="deleteItemConfirm"
            >
              <v-icon>mdi-check</v-icon>
            </v-btn>
            <v-btn
              depressed
              small
              color="primary"
              outlined
              @click="(dialogDelete = false), (deleteId = null)"
              ><v-icon>mdi-close</v-icon></v-btn
            >
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-card>
    <OverlayPageVue :showOverlay="loaderOverlay" />
  </section>
</template>

<script>
import OverlayPageVue from "@/utils/OverlayPage.vue";
import alerts from "@/mixins/alerts";
import BreadCrumb from "@/components/navigations/BreadCrumb.vue";
import treasuryService from "@/services/TreasuryService/treasuryService.js";

export default {
  name: "Deals",
  mixins: [alerts],

  data: () => {
    return {
      loaderOverlay: false,
      dialogDelete: false,
      deleteId: null,
      dialogstatus: false,
      statusdeal_id: null,
      expanded: [],
      headers: [
        { text: "Contract No", value: "deal_no", width: 150 },
        { text: "Contract Type", value: "deal_type", width: 150 },

        { text: "Booking Date", value: "deal_date", width: 150 },
        { text: "Source of Funds", value: "source_of_funds", width: 200 },
        { text: "Amount in USD", value: "fcy_amount", width: 150 },
        { text: "Exchange Rate", value: "fcy_deal_rate", width: 150 },
        { text: "Amount in MYR", value: "lcy_amount", width: 150 },
        { text: "Status", value: "status", width: 100 },
        { text: "Actions", value: "action", width: 100, sortable: false },
        { text: "", value: "data-table-expand", sortable: false, width: 50 },
      ],
      userList: [],
      search: "",
    };
  },

  mounted() {
    this.getRemitteList();
  },

  components: {
    BreadCrumb,
    OverlayPageVue,
  },
  methods: {
    getStatusColor(status) {
      if (status === "open") {
        return "info";
      } else if (status === "close") {
        return "error";
      } else if (status === "settled") {
        return "success";
      } else {
        return "grey";
      }
    },

    stoploader() {
      setTimeout(() => {
        this.loaderOverlay = false;
      }, 400);
    },
    async downloadExcelsheet() {
      if (this.userList) {
        this.exportToExcel(this.headers, this.userList, "IND_Deals");
      }
    },
    async getRemitteList() {
      this.loaderOverlay = true;
      try {
        const responseData = await treasuryService.getAllContract();
        console.log(responseData, "response");
        if (responseData && responseData.data.status_code == 200) {
          this.userList = responseData.data.data;
          console.log("usrelist", this.userList);
          this.stoploader();
        } else {
          this.loaderOverlay = false;
          this.showAlertError(responseData.data.message);
        }
      } catch (err) {
        console.log(err);
        this.loaderOverlay = false;
        this.showAlertError("Fetched data Failed: Something went wrong");
      }
    },
    deleteItem(item) {
      this.dialogDelete = true;
      this.deleteId = item.deal_id;
    },

    updateStatus(item) {
      this.dialogstatus = true;
      this.statusdeal_id = item.deal_id;
    },

    newDealClick() {
      this.$router.push({
        name: "New Deal",
      });
    },

    updateDeal(item) {
      this.$router.push({
        name: "New Deal",
        query: { id: item.deal_id },
      });
    },

    async isactiveupdate() {
      this.loaderOverlay = true;
      try {
        const responseData = await treasuryService.updateContractStatus(
          this.statusdeal_id,
          true,
          {}
        );
        if (responseData && responseData.data.status_code == 200) {
          this.showAlertSuccess(responseData.data.message);
          this.stoploader();
          this.dialogstatus = false;
          this.getRemitteList();
        } else {
          this.showAlertError(responseData.data.message);
          this.loaderOverlay = false;
        }
        console.log("respose data", responseData);
      } catch (e) {
        console.log(e);
        this.loaderOverlay = false;
        this.showAlertError("Something went wrong please try again later.");
      }
    },

    format(date) {
      if (date) {
        date = new Date(date);
        let month = date.toLocaleString("en-US", { month: "short" });
        return date.getDate() + " " + month + " " + date.getFullYear();
      }
    },
    async deleteItemConfirm() {
      try {
        const responseData = await treasuryService.deleteContract(
          this.deleteId
        );
        console.log(responseData, "response");
        if (responseData && responseData.data.status_code == 200) {
          this.getRemitteList();
          this.showAlertSuccess(responseData.data.message);
          this.dialogDelete = false;
        } else {
          this.showAlertError(responseData.data.message);
        }
      } catch (err) {
        console.log("Deal not posted", err);
      }
    },
    newSettlementClicked(selectedRow) {
      console.log("selectedRow", selectedRow);

      // this.$store.commit("app/set_selected_deal_id", selectedRow.deal_id);
      this.$router.push({
        name: "Settlements",
        query: { id: selectedRow.deal_id },
      });
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/global.scss";

.title-lbl {
  width: 100%;
  padding: 5px;
  text-align: center;
  font-weight: bold;
  color: $txt;
  border-bottom: 1px solid $txt;
}

.menu-sec {
  margin-top: 0.5rem;
  .v-list-item {
    min-height: 36px;
    label {
      width: 50%;
    }
  }
}
</style>
